// Dependencies
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Actions
import { toggleFeatureDescription } from '../actions';

// Shapes
import { featureShape, propertiesShape } from '../propTypesShapes';
import { profileShape } from '../../authentication/propTypesShapes';

// Contants
import { ACCOUNT, IGNORE_FIELDS, CSS_TO_CATEGORY_MAP } from '../constants';

// Utils
import HtmlText from '../../shared/components/HtmlText';

// Assets
import './PlaceDescription.css';


const UPPERCASE_IGNORE_FIELDS = IGNORE_FIELDS.map(s => s.toUpperCase());


const Field = ({ name, value }) => {
  if (!(name && value)) {
    return null;
  }

  let valueContent;

  if (_.isString(value)) {
    valueContent = <HtmlText text={value} />;
  } else {
    valueContent = value;
  }

  return (
    <p>
      <strong>{name}</strong><br />
      {valueContent}
    </p>
  );
};
Field.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

export const DescriptionContent = ({ profile, featureProperties }) => {
  const { account, data: { title: cssFileName } } = profile;

  // use predefined html template if customer is VDFS
  if (account !== ACCOUNT.VFDS_ACCOUNT) {
    const renderedFeatureProps = Object.entries(featureProperties).filter(
      ([key, value]) => !UPPERCASE_IGNORE_FIELDS.includes(key.toUpperCase())
    );

    return renderedFeatureProps.map(([key, value]) => (
      <Field
        key={key}
        name={key}
        value={value}
      />
    ));
  }

  const {
    Address, Website, Telephone, Email, Description,
    'Cobseo Registered?': cobseoRegistered, Postcode
  } = featureProperties;

  return (
    <React.Fragment>
      <Field
        name="ADDRESS"
        value={Postcode ? `${Address} ${Postcode}` : Address}
      />
      <Field
        name="CONTACT"
        value={(
          <React.Fragment>
            {Telephone && (
              <span>
                {Telephone}
                <br />
              </span>
            )}
            {Email && (
              <span>
                <span dangerouslySetInnerHTML={{ __html: Email }} />
                <br />
              </span>
            )}
            {Website && (
              <span>
                <span dangerouslySetInnerHTML={{ __html: Website }} />
                <br />
              </span>
            )}
          </React.Fragment>
        )}
      />
      {!CSS_TO_CATEGORY_MAP[cssFileName] && (
        <Field
          name="COBSEO REGISTERED?"
          value={cobseoRegistered}
        />
      )}
      <Field
        name="DESCRIPTION"
        value={Description}
      />
    </React.Fragment>
  );
};
DescriptionContent.propTypes = {
  profile: profileShape,
  featureProperties: propertiesShape
};

class PlaceDescription extends PureComponent {
  static propTypes = {
    profile: profileShape,
    feature: featureShape,
    dispatch: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.handleExpandingArrowOnClick = this.handleExpandingArrowOnClick.bind(this);
  }

  handleExpandingArrowOnClick() {
    const { dispatch } = this.props;

    dispatch(toggleFeatureDescription());
  }

  render() {
    const { feature, profile } = this.props;
    const { name } = feature.properties;

    return (
      <div className="PlaceDescription">
        <h3>{name}</h3>
        <button className="ExpandingArrowButton" onClick={this.handleExpandingArrowOnClick} />
        <DescriptionContent
          profile={profile}
          featureProperties={feature.properties}
        />
      </div>
    );
  }
}

export default PlaceDescription;
